module.exports = __webpack_public_path__ + "img/product_7.10e3cab.webp";